// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_gz-6";
export var emphasizeQuantity = "_gz-3";
export var flatBottomCorners = "_gz-5";
export var productImage = "_gz-0";
export var quantityContainer = "_gz-2";
export var tooltip = "_gz-1";
export var wrapAndEllipsesOverflow = "_gz-4";